import React, { useEffect, useState } from 'react'
import AppContext from './AppContext';
import { jwtDecode } from 'jwt-decode';

const AppStates = (props) => {

    const [userName, setUserName] = useState(localStorage.getItem("email"));
    const [userToken, setToken] = useState(localStorage.getItem("token"));

    useEffect(()=>{

        const sessionToken = localStorage.getItem("token");
        const sessionEmail = localStorage.getItem("email");

        if(userName === null) setUserName(sessionEmail);
        if(userToken === null) setToken(sessionToken);
    },[])

    const uploadToken = (token) =>{
      try{
        let decodedToken = jwtDecode(token);
        setToken(token);
        setUserName(decodedToken?.userEmail);
        localStorage.setItem("token", token);
        localStorage.setItem("email", decodedToken?.userEmail);
      }
      catch( e ){
        console.log(e)
        throw new Error(e)
      }
    }

    const getToken = () => userToken;

    const getAuthStat = () => {
      try{
        return jwtDecode(userToken).userRole
      } 
      catch( e ){
        return "QC"
      }
    };

  return (
    <AppContext.Provider value={{uploadToken, getToken, getAuthStat, userName}} >
        { props.children }
    </AppContext.Provider>
  )
}

export default AppStates